// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fre4Y","type":"styles_type__1XSLG","choices":"styles_choices__wVfK0"};